import { useI18nContext } from "@hopper-b2b/i18n";
import { Loading } from "@tenant/ui";

export const HotelShopPriceLoading = () => {
  const { t } = useI18nContext();
  return <Loading label={t("loadingWithEllipsis")} />;
};
